import { useZodForm } from '../../../utils';
import {
  CustomInstallationConfig,
  customInstallationScript,
} from '../../../validations';

export const DEFAULT_WIDGET_CONFIG = {
  leadColor: '#146ff8',
  language: 'en',
  position: 'left',
  triggerColor: '#146ff8',
  triggerPositionX: 'right',
  triggerPositionY: 'bottom',
  triggerSize: 'medium',
  triggerRadius: '50%',
  hideTrigger: 'false',
  triggerOffsetX: '20',
  triggerOffsetY: '20',
  triggerIcon: 'LegacyPeople',
  hideMobile: 'false',
  mobileTriggerPositionX: 'right',
  mobileTriggerPositionY: 'bottom',
  mobileTriggerSize: 'small',
  mobileTriggerRadius: '50%',
  mobileTriggerOffsetX: '10',
  mobileTriggerOffsetY: '10',
  statementLink: '',
  footerHtml: '',
  consistentHelpData: [{ title: '', description: '' }],
} satisfies CustomInstallationConfig;

export function useInstallationForm(
  widgetConfig: CustomInstallationConfig = DEFAULT_WIDGET_CONFIG,
) {
  return useZodForm(customInstallationScript, {
    values: widgetConfig,
  });
}
